import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import moment from 'moment';
import ReactTooltip from 'react-tooltip';
import ReactImageFallback from 'react-image-fallback';
import Scrollbars from 'react-custom-scrollbars';
import {
  FALLBACK_ICON, OFFER_TYPE, dateFormats, capitalizeEveryWord, routeConstants, history, staticConstants, formatedCurrency,
} from '../../utils';

function AssociatedOffers(props) {
  const {
    associatedData, isManagerDetail, totalOffer, revenue, canNavToOffer,
  } = props;
  const redirectOnDetail = (offerId) => {
    const pathToRedirect = isManagerDetail ? staticConstants.COMPONENT_KEYWORDS.ADMIN_MANAGER_PAGE : staticConstants.COMPONENT_KEYWORDS.ADMIN_ARTIST_PAGE;
    history.push({
      pathname: `${routeConstants.OFFER_DETAIL}/${offerId}`,
      state: { isFrom: pathToRedirect },
    });
  };

  const completedGigs = `${totalOffer === 1 ? 'gig' : 'gigs'}`;
  const associatedGigs = associatedData && `${associatedData.associatedCount === 1 ? 'gig' : 'gigs'}`;

  const renderAssociateOffers = () => map(associatedData.data, (item) => {
    const offerImage = `${item.offerData.clientLogo}?${Math.random()}`;
    return item && (
      <div className="offer-column-row" key={Math.random()}>
        <span className="offer-column-icon">
          <img
            src={offerImage || FALLBACK_ICON}
            className="image-cover"
            alt="User"
            crossOrigin="anonymous"
          />
        </span>
        <div
          className="offer-column-details cursor-pointer"
          onClick={() => {
            canNavToOffer && redirectOnDetail(item.offerData._id);
          }}
        >
          <p>{capitalizeEveryWord(item.offerData.title)}</p>
          <h4>
            {moment(item.offerData.offerMinDate).format(dateFormats.DATE_WITHOUT_YEAR)}
            {' '}
            -
            {moment(item.offerData.offerMaxDate).format(dateFormats.DATE_WITHOUT_YEAR)}
          </h4>
          <h3>
            $
            {formatedCurrency(item.basePrice)}
            <strong>{OFFER_TYPE[item.offerData.viewType]}</strong>
            {(item.offerStatus === 'onGoing')
                && <em>On going</em>}
            {(item.offerStatus === 'contractPending')
                && <em className="pending-tag">contract pending</em>}
            {(item.offerStatus === 'completed')
                && <em className="completed-tag">Completed</em>}
          </h3>
          { isManagerDetail
          && (
          <>
            <span data-tip="" data-place="bottom">
              <ReactImageFallback
                src={item.userId.artistImage}
                fallbackImage={FALLBACK_ICON}
                className="image-cover"
                alt="User"
              />
            </span>
            <ReactTooltip
              className="customToolTip"
            >
              <div>{capitalizeEveryWord(item.userId.name)}</div>
            </ReactTooltip>
          </>
          )}
        </div>
      </div>
    );
  });

  return (
    <>
      <div className="modal-artist-detail-offer-head" data-html2canvas-ignore="true">
        <p>
          {totalOffer > 0 ? `Completed ${completedGigs} (${totalOffer})` : 'No Gigs Completed'}
        </p>
        <h4 className="mb-4">
          Revenue: $
          {formatedCurrency(revenue)}
        </h4>
        <p>
          {associatedData.associatedCount > 0 ? `Associated ${associatedGigs} (${associatedData.associatedCount})` : 'No Gigs Associated'}
        </p>
      </div>
      {
        associatedData.data.length > 0
      && (
        <div className="modal-artist-detail-offer-column" data-html2canvas-ignore="true">
          {
            isManagerDetail
              ? (
                <Scrollbars
                  style={{ width: '100%', height: 240 }}
                  autoHeightMax={100}
                  thumbMinSize={30}
                >
                  {renderAssociateOffers()}
                </Scrollbars>
              )
              : renderAssociateOffers()
          }
        </div>
      )
      }
    </>
  );
}

AssociatedOffers.propTypes = {
  associatedData: PropTypes.object.isRequired,
  isManagerDetail: PropTypes.bool,
  revenue: PropTypes.number,
  totalOffer: PropTypes.number,
  canNavToOffer: PropTypes.bool,
};

AssociatedOffers.defaultProps = {
  isManagerDetail: false,
  revenue: 0,
  totalOffer: 0,
  canNavToOffer: true,
};

export default AssociatedOffers;
